module.exports = __webpack_public_path__ + "static/media/Participated_Events_Banner.7ea9e6c1.png";